export default {"src":"/_next/static/media/language-icon.0b3f1a42.svg","height":16,"width":16};